import {MapByStr} from "../../models/common/Map";
import {
    GeneralFormActions,
    LOCK_FORM_VALUES,
    REMOVE_ALL_LOCKED_FORM_VALUES,
    REMOVE_LOCKED_FORM_VALUE
} from "../../actions/common/FormActions";


export interface FormReducerState {

    /**
     * key is the view identifier of the form
     */
    forms: { [key: string]: MapByStr<any> };
}

const initialState: FormReducerState = {
    forms: {}
};

export function FormReducer(
    state: FormReducerState = initialState,
    action: GeneralFormActions
) {

    switch( action.type ) {

        case LOCK_FORM_VALUES:
            return {
                forms: {
                    ...state.forms,
                    [ action.viewIdentifier ]: action.lockedValues
                }
            };
        case REMOVE_LOCKED_FORM_VALUE:
            const formState = state.forms[ action.viewIdentifier ];
            delete formState[ action.keyToRemove ];
            return {
                forms: {
                    ...state.forms,
                    [ action.viewIdentifier ]: formState
                }
            };
        case REMOVE_ALL_LOCKED_FORM_VALUES:
            const _state = state.forms;
            delete _state[ action.viewIdentifier ];
            return {
                forms: _state
            }
        default:
            return state;
    }


}
